import { useQuery } from '@tanstack/react-query';
import { apiClientV2 } from '~/api/client';
import { WHALAR_MODE_TALENT_TT_INSIGHTS } from '~/queries/keys';

export const useGetCreatorTTInsights = (insightId?: string) =>
  useQuery({
    queryKey: [WHALAR_MODE_TALENT_TT_INSIGHTS, { insightId }],
    queryFn: () => apiClientV2.get(`creator-tiktok-insights/${insightId}`),
    staleTime: 1000 * 60 * 30, // 30 minutes
    enabled: Boolean(insightId),
  });
